<template>
  <div class="modal-content">
    <form class="form-relative" novalidate @submit.prevent="createFilter">
      <div
        ref="content"
        class="form-in-scroll"
        style="scrollbar-gutter: stable both-edges"
      >
        <ErrorMessage
          v-if="errorMessage"
          :error-message="errorMessage"
        ></ErrorMessage>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label class="form-control-label"
                >Название фильтра<span>*</span></label
              >
              <input
                :value="formData.name"
                @input="
                  removeSpaces($event);
                  updateParameter($event.target.value, 'name');
                "
                type="text"
                class="form-control form-control-light"
                :class="{ 'is-invalid': $v.formData.name.$error }"
                placeholder="Название фильтра"
                required
                data-v-step="filter-name-input"
                ref="filterNameInput"
              />
              <div
                v-if="$v.formData.name.$dirty && !$v.formData.name.required"
                class="invalid-feedback"
              >
                Поле обязательно для заполнения
              </div>
              <div v-if="isNameAlreadyExist" class="invalid-feedback">
                Название фильтра должно быть уникальным.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group form-group-budget">
              <label class="form-control-label">Бюджет</label>
              <div class="row">
                <div class="col-6 budget">
                  <input
                    type="text"
                    class="form-control form-control-light"
                    :class="{ 'is-invalid': isBudgetInvalid }"
                    placeholder="от"
                    :value="formData.budgetFrom"
                    @focus="isBudgetInvalid = false"
                    @change="updateParameter($event.target.value, 'budgetFrom')"
                    v-mask="{
                      alias: 'decimal',
                      inputMode: 'numeric',
                      groupSeparator: ' ',
                      placeholder: '',
                      showMaskOnHover: false,
                      rightAlign: false,
                    }"
                  />
                </div>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control form-control-light"
                    :class="{ 'is-invalid': isBudgetInvalid }"
                    placeholder="до"
                    :value="formData.budgetTo"
                    @focus="isBudgetInvalid = false"
                    @change="updateParameter($event.target.value, 'budgetTo')"
                    v-mask="{
                      alias: 'decimal',
                      inputMode: 'numeric',
                      groupSeparator: ' ',
                      placeholder: '',
                      showMaskOnHover: false,
                      rightAlign: false,
                    }"
                  />
                </div>
              </div>
              <div v-if="this.isBudgetInvalid" class="invalid-feedback">
                Нижняя граница заданного бюджета не может превышать верхнюю
                границу
              </div>
            </div>
          </div>
        </div>
        <div class="form-places" v-if="placesTypes.length > 0">
          <label
            class="places-item"
            v-for="place in placesTypes"
            :key="place[trackBy]"
          >
            <input
              type="checkbox"
              :value="place[trackBy]"
              :checked="isChecked(place)"
              @change="onChangePlaceType"
            />
            <span class="checkbox-icon"></span>
            {{ removeProtocol(place[label]) }}
          </label>
        </div>
        <div class="form-group">
          <div class="form-control-label-wrapper">
            <label class="form-control-label">Ключевые слова</label>
            <Hint>
              <key-words-hint />
            </Hint>
          </div>
          <MultipleInput
            @updateFilter="updateParameter(...arguments, 'keyWords')"
            :placeholder="'Ключевые слова для фильтрации закупок'"
            :isVertical="true"
            :selected-values="formData.keyWords"
            data-v-step="filter-keywords-multiple-input"
          ></MultipleInput>
        </div>
        <div class="form-group">
          <div class="form-control-label-wrapper">
            <label class="form-control-label">Исключения</label>
            <Hint>
              <exclude-words-hint />
            </Hint>
          </div>
          <MultipleInput
            @updateFilter="updateParameter(...arguments, 'excludeWords')"
            :placeholder="'Ключевые слова, которые будут исключены из поиска'"
            :isVertical="true"
            :selected-values="formData.excludeWords"
            data-v-step="filter-exclude-words-multiple-input"
          ></MultipleInput>
        </div>
        <div class="form-group">
          <div class="form-control-label-wrapper">
            <label class="form-control-label">Регион</label>
            <Hint>
              <region-words-hint />
            </Hint>
          </div>
          <MultipleInput
            @updateFilter="updateParameter(...arguments, 'regions')"
            :placeholder="'Укажите интересующие регионы'"
            :isVertical="true"
            :selected-values="formData.regions"
            data-v-step="filter-region-multiple-input"
          ></MultipleInput>
        </div>
        <div class="form-group">
          <div class="form-control-label-wrapper">
            <label class="form-control-label">Название организации / УНП</label>
            <Hint><OrganizationNameHint /></Hint>
          </div>
          <MultipleInput
            @updateFilter="updateParameter(...arguments, 'organizations')"
            :placeholder="'Введите ключевые слова и/или УНП для поиска организаций'"
            :isVertical="true"
            :selected-values="formData.organizations"
          ></MultipleInput>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label class="form-control-label">Вид закупки</label>
              <EntitySelect
                :value="formData.purchasesTypes"
                :entities="purchasesTypes"
                :multiple="true"
                :placeholder="'Все'"
                :is-updatable="true"
                @onChange="onChangePurchaseType"
                @onLoad="getProceduresTypes"
                :wideDropdown="true"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label class="form-control-label">Отрасль</label>
              <TreeselectEntity
                :value="formData.sectorsTypes"
                :entities="sectorsTypes"
                :multiple="true"
                placeholder="Все"
                :is-updatable="true"
                @onChange="onChangeSectorType"
                @onLoad="getSectorsTypes"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <div class="form-control-label-wrapper">
                <label class="form-control-label">Код ОКРБ</label>
                <Hint class="hint-okrb">
                  <div class="hint-content" style="min-width: 300px">
                    <p>
                      Код ОКРБ имеет специальный формат ХХ.ХХ.ХХ.ХХХ и
                      отличается в зависимости от группы товаров
                    </p>
                  </div>
                </Hint>
              </div>
              <MultipleInput
                @updateFilter="updateParameter(...arguments, 'codesOKRB')"
                :placeholder="'Коды ОКРБ'"
                :isVertical="true"
                :inputmask="{
                  mask: '99[.99][.99][.999]',
                  greedy: false,
                  placeholder: '',
                  showMaskOnHover: false,
                }"
                :selected-values="formData.codesOKRB"
              ></MultipleInput>
            </div>
          </div>
        </div>

        <transition name="animate-notification">
          <div v-if="anyNotificationEnabled" class="form-notifications">
            <div class="form-group">
              <div class="form-control-label-wrapper">
                <label class="form-control-label email-title"
                  >Уведомления о новых тендерах</label
                >
              </div>
              <div class="form-control-checkbox">
                <label
                  v-for="(day, index) in daysOfWeek"
                  :key="index"
                  class="checkbox-day"
                >
                  <input
                    :value="formData.daysNotification"
                    type="checkbox"
                    :checked="selectedDays.includes(day)"
                    @change="toggleDay(day, $event)"
                  />
                  <span>{{ day }}</span>
                </label>
              </div>
              <div class="form-control-chips-time">
                <label class="form-control-label time-position"
                  >Время получения</label
                >
                <TimePicker
                  @updateTime="
                    updateParameter(...arguments, 'timeNotification')
                  "
                  :value="formData.timeNotification"
                  :selectedTimes="formData.timeNotification"
                />
              </div>
            </div>
            <div class="form-notifications__settings">
              <NotificationToggle
                label="Присылать уведомления в Telegram"
                :value="formData.telegramEnabled"
                @change="tgNotificationsToggle($event)"
              />
              <TgNotificationButton
                :mode="componentProps.mode"
                :telegramEnabled="formData.telegramEnabled"
                :tab-id="componentProps.tabId"
                @telegram-bot-opened="telegramBotOpenedHandler($event)"
              />
              <NotificationToggle
                label="Присылать уведомления на Email"
                :value="formData.notificationEnabled"
                @change="updateParameter($event, 'notificationEnabled')"
              />
              <transition name="animate-notification">
                <div class="form-group" v-if="formData.notificationEnabled">
                  <div
                    v-for="(email, index) in emails"
                    :key="index"
                    class="form-control-email"
                  >
                    <input
                      class="email-item form-control"
                      ref="emailNotification"
                      type="email"
                      placeholder="Введите Email"
                      v-model.trim="emails[index]"
                      @input="updateEmailNotification"
                      :class="{ 'is-invalid': $v.formData.emails.$error }"
                      required
                    />
                    <div
                      v-if="
                        $v.formData.emails.$dirty && !$v.formData.emails.email
                      "
                      class="invalid-feedback"
                    >
                      Некорректный E-mail
                    </div>
                    <div
                      v-if="
                        $v.formData.emails.$dirty &&
                        !$v.formData.emails.maxLength
                      "
                      class="invalid-feedback"
                    >
                      Поле должно содержать не более
                      {{ $v.formData.emails.$params.maxLength.max }} символов
                    </div>
                    <button
                      type="button"
                      v-if="index === 0"
                      @click="addEmailField"
                      class="add-email-btn"
                      :disabled="emails.length > 1"
                    >
                      <img
                        src="../../assets/img/add-btn.svg"
                        alt="add"
                        :class="{ 'icon-disabled': emails.length > 1 }"
                      />
                    </button>
                    <button
                      type="button"
                      v-if="index > 0"
                      @click="removeEmailField(index)"
                      class="delete-icon"
                    >
                      <img src="../../assets/img/icon-trash.svg" alt="delete" />
                    </button>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </transition>
      </div>

      <div class="form-footer form-footer-fixed">
        <NotificationToggle
          label="Присылать уведомления о новых тендерах"
          :value="anyNotificationEnabled"
          @change="toggleAnyNotificationEnabled($event)"
        />
        <div class="btn-group">
          <template>
            <div
              class="toolTip-container"
              @mouseenter="showTooltip = true"
              @mouseleave="showTooltip = false"
            >
              <button
                class="btn btn-middle btn-copy"
                type="button"
                :disabled="isDisabled"
                :title="isDisabled ? 'Введите название фильтра' : ''"
                @click="copyFilter()"
              >
                <img src="../../assets/img/icon-copy.svg" />
              </button>
              <transition name="fade">
                <div
                  class="tooltip"
                  :class="{ show: showTooltip && !isDisabled }"
                >
                  Сделать копию фильтра
                </div>
              </transition>
            </div>
          </template>
          <button
            class="btn btn-middle"
            style="width: 160px"
            type="button"
            :disabled="isDisabled"
            :title="isDisabled ? 'Введите название фильтра' : ''"
            @click="
              componentProps.mode === 'Create' ? createFilter() : editFilter()
            "
            data-v-step="create-filter-confirm-button"
          >
            Сохранить
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import Hint from "@/components/common/Hint";
import MultipleInput from "@/components/purchasesTableCustomFilter/MultipleInput";
import { mapActions, mapGetters } from "vuex";
import EntitySelect from "../common/EntitySelect";
import ErrorMessage from "@/components/common/ErrorMessage";
import { generateTabFilters } from "@/utils/rsql";
import { and } from "rsql-builder";
import { createFilterData } from "@/utils/mapper";
import { purchasesPath } from "@/router/purchases";
import KeyWordsHint from "../hints/KeyWordsHint";
import ExcludeWordsHint from "../hints/ExcludeWordsHint";
import RegionWordsHint from "../hints/RegionWordsHint";
import TimePicker from "../timePicker/TimePicker.vue";
import {
  convertDaysToEnglish,
  convertDaysToRussian,
} from "../../utils/converter-days";
import { sendNotificationEmail } from "../../application/requests/notificationsRequests";
import { PurchasesTableEditCustomFilterModalProperties } from "@/utils/modalsProperties";
import PurchasesTableCustomFilterModal from "@/components/purchasesTableCustomFilter/PurchasesTableCustomFilterModal";
import TreeselectEntity from "../common/TreeselectEntity.vue";
import OrganizationNameHint from "../hints/OrganizationNameHint.vue";
import NotificationToggle from "../purchasesTableSettings/NotificationToggle.vue";
import TgNotificationButton from "../purchasesTableSettings/TgNotificationButton.vue";

export default {
  name: "purchasesTableCustomFilterModal",
  props: ["componentProps"],
  data() {
    return {
      formData: {
        placesTypes: [],
        notificationEnabled: false,
        telegramEnabled: false,
        daysNotification: [],
        timeNotification: [],
        emailNotification: [],
      },
      anyNotificationEnabled:
        this.componentProps.formData.notificationEnabled ||
        this.componentProps.formData.telegramEnabled,
      isBudgetInvalid: false,
      errorMessage: null,
      daysOfWeek: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"],
      selectedDays: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"],
      isEmailShown: false,
      emails: [""],
      trackBy: "id",
      label: "value",
      showTooltip: false,
      isCopying: false,
      copyError: null,
      isInitializing: true,
      telegramBotOpened: false,
      defaultTimeNotification: "08:30",
    };
  },

  components: {
    RegionWordsHint,
    ExcludeWordsHint,
    KeyWordsHint,
    EntitySelect,
    Hint,
    MultipleInput,
    ErrorMessage,
    TimePicker,
    TreeselectEntity,
    OrganizationNameHint,
    NotificationToggle,
    TgNotificationButton,
  },

  validations: {
    formData: {
      name: { required },
      emails: {
        required: function () {
          return this.formData.notificationEnabled ? required : {};
        },
        $each: {
          email: function (value) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(value);
          },
          maxLength: maxLength(50),
        },
      },
    },
  },

  computed: {
    ...mapGetters("enums", ["purchasesTypes", "placesTypes", "sectorsTypes"]),
    ...mapGetters("profile", ["profileId", "hintsEnabled"]),
    ...mapGetters("filterTabs", ["filterTabByParam", "filterTabs"]),
    ...mapGetters("purchasesTableSettings", ["isKeywordShown"]),
    isDisabled: function () {
      return !this.formData.name;
    },
    isNameAlreadyExist() {
      return this.filterTabs.some(
        (tab) => tab.name === this.formData.name && tab.id !== this.formData.id,
      );
    },
  },

  watch: {
    "formData.notificationEnabled": function (value) {
      if (this.isInitializing) return;
      if (this.emails.length === 0) this.emails = [""];
      if (!value && !this.formData.telegramEnabled)
        return (this.anyNotificationEnabled = false);
      this.$nextTick(() => {
        if (value) this.scrollToDown();
      });
    },

    "formData.telegramEnabled": function (value) {
      if (this.isInitializing) return;
      if (!value && !this.formData.notificationEnabled)
        return (this.anyNotificationEnabled = false);
      this.$nextTick(() => {
        if (value) this.scrollToDown();
      });
    },

    anyNotificationEnabled(value) {
      if (this.isInitializing) return;
      this.$nextTick(() => {
        value ? this.scrollToDown() : this.scrollToTop();
      });
    },

    placesTypes: {
      handler(newVal) {
        if (
          !this.formData.placesTypes?.length &&
          Array.isArray(newVal) &&
          newVal.length > 0
        ) {
          this.$nextTick(() => {
            if (!this.formData.placesTypes?.length) {
              this.formData.placesTypes = [...newVal];
            }
          });
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions("filterTabs", [
      "createFilterTab",
      "getFilterTabs",
      "setCurrentTab",
      "editFilterTab",
    ]),
    ...mapActions("enums", [
      "getProceduresTypes",
      "getPlacesTypes",
      "getSectorsTypes",
    ]),

    async telegramBotOpenedHandler(value) {
      this.telegramBotOpened = value;

      const filterData = createFilterData(this.formData);

      filterData.searchQuery = and(
        ...generateTabFilters(filterData.searchCriteria),
      );

      const notificationEmails =
        (this.formData.emailNotification ?? this.emails) || [];

      const notificationDays = this.formData.daysNotification
        ? convertDaysToEnglish(
            this.formData.daysNotification.filter((day) =>
              this.selectedDays.includes(day),
            ),
          )
        : this.formData.daysWeek;

      const notificationData = {
        notificationDays,
        notificationTimes: this.formData.timeNotification,
        notificationEmails: notificationEmails.filter((email) => email),
      };

      await sendNotificationEmail(this.formData.id, notificationData);

      await this.editFilterTab({
        filterId: this.formData.id,
        filterData,
      });
    },

    tgNotificationsToggle(value) {
      if (this.componentProps.mode === "Create") {
        this.errorMessage =
          "Для включения уведомлений в телеграм сперва сохраните фильтр";
        this.scrollToTop();
        return;
      }

      if (value) this.updateEmailNotification();

      this.updateParameter(value, "telegramEnabled");
    },

    removeSpaces(event) {
      if (event.target.value.charAt(0) === " ") {
        event.target.value = "";
      }
    },

    removeProtocol(url) {
      return url.replace(/^https?:\/\//, "");
    },

    compareBudget() {
      const budgetFrom = this.formData.budgetFrom;
      const budgetTo = this.formData.budgetTo;
      if (budgetFrom && budgetTo && Number(budgetFrom) > Number(budgetTo)) {
        this.isBudgetInvalid = true;
        return true;
      }
    },

    validateNotificationType() {
      if (
        this.anyNotificationEnabled &&
        !this.formData.telegramEnabled &&
        !this.formData.notificationEnabled
      ) {
        this.errorMessage = "Включите нужный вид уведомления (Telegram/Email)";
        this.scrollToTop();
        return false;
      }
      return true;
    },

    isChecked(place) {
      if (!Array.isArray(this.formData.placesTypes)) {
        return false;
      }
      return this.formData.placesTypes.some(
        (item) => item[this.trackBy] === place[this.trackBy],
      );
    },

    scrollToTop() {
      if (this.$refs.content) {
        const element = this.$refs.content;
        element.style.scrollBehavior = "smooth";
        element.scrollTop = 0;

        setTimeout(() => {
          element.style.scrollBehavior = "auto";
        }, 500);
      }
    },

    scrollToDown() {
      if (this.$refs.content) {
        const element = this.$refs.content;
        element.style.scrollBehavior = "smooth";
        element.scrollTop = element.scrollHeight;

        setTimeout(() => {
          element.style.scrollBehavior = "auto";
        }, 500);
      }
    },

    toggleAnyNotificationEnabled(value) {
      this.anyNotificationEnabled = value;
      this.formData.notificationEnabled = false;
      this.formData.telegramEnabled = false;
    },

    updateParameter(values, field) {
      this.formData = {
        ...this.formData,
        [field]: values,
      };
    },

    async createFilter() {
      if (this.formData.telegramEnabled && !this.telegramBotOpened) {
        this.errorMessage = "Перейдите в телеграм-бот*";
        this.scrollToTop();
        return;
      }

      if (!this.validateNotificationType()) {
        return;
      }

      if (this.$v.$invalid || this.compareBudget()) {
        this.$v.$touch();
        this.scrollToTop();
        return;
      }

      if (!this.validateEmails()) {
        this.scrollToTop();
        return;
      }

      if (
        !Array.isArray(this.formData.timeNotification) ||
        !this.formData.timeNotification.length
      ) {
        this.formData.timeNotification = [this.defaultTimeNotification];
      }

      this.updateEmailNotification();

      const filterData = createFilterData(this.formData);
      filterData.profile = `/${this.profileId}`;
      filterData.searchQuery = and(
        ...generateTabFilters(filterData.searchCriteria),
      );

      try {
        const response = await this.createFilterTab(filterData);
        await this.getFilterTabs(this.profileId);

        if (
          this.formData.notificationEnabled ||
          this.formData.telegramEnabled
        ) {
          const notificationEmails =
            this.formData.emailNotification || this.emails;

          const notificationData = {
            notificationDays: convertDaysToEnglish(
              this.formData.daysNotification.filter((day) =>
                this.selectedDays.includes(day),
              ),
            ),
            notificationTimes: this.formData.timeNotification,
            notificationEmails: notificationEmails.filter((email) => email),
          };

          await sendNotificationEmail(response.data.id, notificationData);
        }
        if (this.$tours["startTour"].currentStep === 5) {
          this.$tours["startTour"].nextStep();
        }
        this.$router.push(`${purchasesPath}/${response.data.id}`);
        this.setCurrentTab(this.filterTabByParam("id", response.data.id));
        this.$modal.close();
      } catch (e) {
        this.errorMessage = e.message;
        this.scrollToTop();
      }
    },

    async editFilter() {
      if (this.formData.telegramEnabled && !this.telegramBotOpened) {
        this.errorMessage = "Перейдите в телеграм-бот*";
        this.scrollToTop();
        return;
      }

      if (!this.validateNotificationType()) {
        return;
      }

      if (this.$v.$invalid || this.compareBudget()) {
        this.$v.$touch();
        this.scrollToTop();
        return;
      }

      if (!this.validateEmails()) {
        this.scrollToTop();
        return;
      }

      const filterData = createFilterData(this.formData);
      filterData.searchQuery = and(
        ...generateTabFilters(filterData.searchCriteria),
      );

      try {
        if (
          this.formData.notificationEnabled ||
          this.formData.telegramEnabled
        ) {
          const notificationEmails =
            (this.formData.emailNotification ?? this.emails) || [];
          const notificationDays = this.formData.daysNotification
            ? convertDaysToEnglish(
                this.formData.daysNotification.filter((day) =>
                  this.selectedDays.includes(day),
                ),
              )
            : this.formData.daysWeek;

          const notificationData = {
            notificationDays: notificationDays,
            notificationTimes: this.formData.timeNotification,
            notificationEmails: notificationEmails.filter((email) => email),
          };

          await sendNotificationEmail(this.formData.id, notificationData);
        }

        await this.editFilterTab({ filterId: this.formData.id, filterData });

        const tab = this.filterTabByParam("id", this.formData.id);

        if (parseInt(this.$route.params.id) === this.formData.id) {
          this.setCurrentTab(tab);
          this.$modal.close();
          return;
        }

        this.$router.push(`${purchasesPath}/${this.formData.id}`);
        this.setCurrentTab(tab);
        this.$modal.close();
      } catch (e) {
        console.error("Error occurred:", e);
        this.errorMessage = e.message;
        this.scrollToTop();
      }
    },

    async copyFilter() {
      if (this.isDisabled || this.isCopying) return;

      this.isCopying = true;
      this.copyError = null;

      const originalFormData = JSON.parse(JSON.stringify(this.formData));

      try {
        if (this.componentProps.mode === "Create") {
          await this.createFilter();
        } else {
          await this.editFilter();
        }

        await this.$nextTick();

        const copiedFormData = {
          ...originalFormData,
          name: `КОПИЯ_${originalFormData.name}`,
          id: null,
          createdAt: new Date().toISOString(),
        };

        setTimeout(() => {
          this.$modal.show(
            PurchasesTableCustomFilterModal,
            {
              formData: copiedFormData,
              mode: "Create",
            },
            {
              ...PurchasesTableEditCustomFilterModalProperties,
            },
          );
        }, 1000);
      } catch (error) {
        this.$toast.error("Не удалось создать копию фильтра");
      } finally {
        this.isCopying = false;
      }
    },

    onChangePurchaseType(value) {
      this.updateParameter(value, "purchasesTypes");
    },

    onChangePlaceType(event) {
      const id = event.target.value;
      const isChecked = event.target.checked;

      if (!Array.isArray(this.formData.placesTypes)) {
        this.formData.placesTypes = [];
      }

      if (isChecked) {
        const selectedPlace = this.placesTypes.find(
          (place) => place.id === parseInt(id),
        );
        if (selectedPlace) {
          this.formData.placesTypes.push(selectedPlace);
        }
      } else {
        if (this.formData.placesTypes.length > 1) {
          this.formData.placesTypes = this.formData.placesTypes.filter(
            (place) => place.id !== parseInt(id),
          );
        } else {
          event.target.checked = true;
        }
      }
    },

    onChangeSectorType(value) {
      this.updateParameter(value, "sectorsTypes");
    },

    addEmailField() {
      if (this.emails.length < 2) {
        this.emails.push("");
        this.isAddDisabled = true;
        this.updateEmailNotification();
      }
    },

    removeEmailField(index) {
      if (index > 0) {
        this.emails.splice(index, 1);
        this.updateEmailNotification();
      }
    },

    updateEmailNotification() {
      this.formData.daysNotification = [...this.daysOfWeek];
      this.formData.emailNotification = [...this.emails];
    },

    toggleDay(day, event) {
      const index = this.selectedDays.indexOf(day);

      if (index > -1 && this.selectedDays.length === 1) {
        event.target.checked = true;
        return;
      }
      if (index > -1) {
        this.selectedDays.splice(index, 1);
      } else {
        this.selectedDays.push(day);
      }

      this.formData.daysNotification = [...this.selectedDays];
    },

    initializeFieldsNotification() {
      if (this.formData.notificationEnabled || this.formData.telegramEnabled) {
        this.selectedDays = Array.isArray(this.formData.daysWeek)
          ? convertDaysToRussian(this.formData.daysWeek)
          : [];
        this.emails = Array.isArray(this.formData.emailNotification)
          ? [...this.formData.emailNotification]
          : [""];
        this.formData.timeNotification = Array.isArray(
          this.formData.timeNotification,
        )
          ? [...this.formData.timeNotification]
          : [];
      } else {
        this.selectedDays = ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"];
        this.emails = [""];
        this.formData.timeNotification = [this.defaultTimeNotification];
      }
    },

    validateEmails() {
      const invalidEmails = this.emails.filter((email) => {
        const trimmedEmail = email?.trim();
        const emailValidation =
          trimmedEmail &&
          /^(?!.*\.\.)(?!.*\.$)[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail) &&
          !/\s/.test(trimmedEmail);
        return !emailValidation;
      });

      const tooLongEmails = this.emails.filter((email) => {
        const trimmedEmail = email?.trim();
        return trimmedEmail && trimmedEmail.length > 50;
      });

      if (
        this.formData.notificationEnabled &&
        (invalidEmails.length > 0 || tooLongEmails.length > 0)
      ) {
        this.errorMessage =
          invalidEmails.length > 0
            ? "Некорректный E-mail"
            : "Поле E-mail должно содержать не более 50 символов";
        return false;
      }
      return true;
    },
  },

  created() {
    this.getPlacesTypes();
    this.formData = { ...this.componentProps.formData };
    this.initializeFieldsNotification();
  },

  mounted() {
    this.$nextTick(() => {
      this.scrollToTop();
      this.isInitializing = false;
    });
    if (!this.$tours["startTour"].isRunning && this.hintsEnabled) {
      this.$tours["startTour"].start("1");
    }
    this.$refs["filterNameInput"].focus();
  },
};
</script>

<style lang="less">
@import "../../assets/less/variables.less";
@import "../../assets/less/bootstrapGrid.less";
@import "../../assets/less/commonStyles.less";

.budget {
  position: relative;

  &::after {
    content: "-";
    position: absolute;
    right: -2px;
    top: 14px;
    z-index: 1;
    color: @bg-color;
  }
}

.animate-notification-enter,
.animate-notification-leave-active {
  opacity: 0;
}

.animate-notification-enter-active {
  transition: all 0.1s ease;
  opacity: 1;
}

.animate-notification-leave-active {
  transition: all 0.2s ease;
  opacity: 0;
}

.row {
  display: flex;
  justify-content: center;

  .col-6 {
    flex: 1;
    min-width: 0;
  }
}

.email-title {
  margin: 10px 0;
}

.form-control-checkbox {
  display: flex;
  flex-wrap: wrap;
  min-width: 300px;
  gap: 5px;
  margin: 15px 0 5px 0;

  .checkbox-day {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .checkbox-day input[type="checkbox"] {
    display: none;
  }

  .checkbox-day span {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 32px;
    padding: 5px 15px;
    border: 1px solid #cfd8dd;
    border-radius: 4px;
    background-color: transparent;
    transition: background-color 0.3s;
  }

  .checkbox-day input[type="checkbox"]:checked + span {
    background-color: #7d919b;
    color: #fff;
  }
}

.form-control-chips-time {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 5px;

  .time-position {
    display: flex;
    flex-direction: column;
    padding-top: 10px;
  }

  .filters-container {
    border: none;
  }
}

.form-control-email {
  display: flex;
  gap: 5px;

  .email-item {
    width: 420px;
    height: 40px;
    margin-bottom: 5px;
    padding: 0 24px 0 16px;
    border-radius: 3px;
    border: 2px solid #cfd8dd;
  }

  .icon-disabled {
    opacity: 0.5;
    cursor: auto;
  }
}

.form-places {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  flex-wrap: wrap;
  padding: 10px 0 15px 0;
  row-gap: 10px;

  align-items: center;
  justify-content: flex-start;

  .places-item {
    display: flex;
    padding: 5px 0;
    width: 180px;
    gap: 5px;
    align-items: center;
    cursor: pointer;

    input[type="checkbox"] {
      display: none;
    }

    .checkbox-icon {
      width: 20px;
      height: 20px;
      background-image: url("../../assets/img/check-off.svg");
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
      flex-shrink: 0;
      transition: background-image 0.2s ease, opacity 0.2s ease;
    }

    input[type="checkbox"]:checked + .checkbox-icon {
      background-image: url("../../assets/img/check-on.svg");
      opacity: 1;
    }
  }
}

.hint-okrb {
  .hint {
    position: absolute;
    top: -50px;
    right: 100%;
    min-height: 70px;
  }
}

.btn-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  position: relative;

  .btn-copy {
    width: 48px;
    height: 48px;
  }
}

.toolTip-container {
  position: relative;
  display: inline-block;

  .tooltip {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-85%);
    background-color: #7d919b;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    white-space: nowrap;
    margin-bottom: 8px;
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
  }

  .tooltip.show {
    opacity: 0.9;
  }
}

.form-notifications {
  display: flex;
  justify-content: space-between;
  .form-notifications__settings {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-top: 45px;
    width: 100%;
    max-width: 301px;
  }
}
</style>
